import { render, staticRenderFns } from "./Lexicon.vue?vue&type=template&id=7f60ac2d&scoped=true&"
import script from "./Lexicon.vue?vue&type=script&lang=js&"
export * from "./Lexicon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f60ac2d",
  null
  
)

export default component.exports